/* eslint-disable @typescript-eslint/no-explicit-any */
//  TODO: Work on better types and implementation to avoid any

export function isEqual(x: any, y: any, seen: WeakSet<object> = new WeakSet()): boolean {
    if (x === y) {
        return true;
    }
    if (typeof x !== "object" || x === null || typeof y !== "object" || y === null) {
        return false;
    }

    if (seen.has(x) || seen.has(y)) {
        console.warn("Circular reference detected in isEqual");
        return false;
    }
    seen.add(x);
    seen.add(y);

    const ok = Object.keys;
    return ok(x).length === ok(y).length && ok(x).every((key) => isEqual(x[key], y[key], seen));
}
/* eslint-disable @typescript-eslint/no-explicit-any */
//  TODO: Work on better types and implementation to avoid any

export function isEqual(x: any, y: any, seen: WeakSet<object> = new WeakSet()): boolean {
    if (x === y) {
        return true;
    }
    if (typeof x !== "object" || x === null || typeof y !== "object" || y === null) {
        return false;
    }

    if (seen.has(x) || seen.has(y)) {
        console.warn("Circular reference detected in isEqual");
        return false;
    }
    seen.add(x);
    seen.add(y);

    const ok = Object.keys;
    return ok(x).length === ok(y).length && ok(x).every((key) => isEqual(x[key], y[key], seen));
}
